export const DEFAULT_MENU_LIST = [
  {
    id: 'menu_home',
    parentId: '0',
    menuName: '首页',
    menuCode: 'HOME',
    routePath: '/home',
    sortNo: 1,
    isVisible: 1
  },
  {
    id: 'menu_income',
    parentId: '0',
    menuName: '短剧投放',
    menuCode: 'INCOME',
    routePath: '/income',
    sortNo: 2,
    isVisible: 1
  },
  {
    id: 'menu_resolve',
    parentId: '0',
    menuName: '数据解析',
    menuCode: 'RESOLVE',
    routePath: '/resolve',
    sortNo: 3,
    isVisible: 1
  },
  {
    id: 'menu_adm',
    parentId: '0',
    menuName: '用户管理',
    menuCode: 'ADM',
    routePath: '/adm',
    sortNo: 4,
    isVisible: 1
  },
  {
    id: 'menu_income_static',
    parentId: 'menu_income',
    menuName: '投放数据',
    menuCode: 'INCOME_STATIC',
    routePath: '/income/static',
    sortNo: 201,
    isVisible: 1
  },
  {
    id: 'menu_income_import',
    parentId: 'menu_income',
    menuName: '导入记录',
    menuCode: 'INCOME_IMPORT',
    routePath: '/income/import',
    sortNo: 202,
    isVisible: 1
  },
  {
    id: 'menu_resolve_address',
    parentId: 'menu_resolve',
    menuName: '地址解析',
    menuCode: 'RESOLVE_ADDRESS',
    routePath: '/resolve/address',
    sortNo: 301,
    isVisible: 1
  },
  {
    id: 'menu_adm_user',
    parentId: 'menu_adm',
    menuName: '人员管理',
    menuCode: 'ADM_USER',
    routePath: '/adm/user',
    sortNo: 401,
    isVisible: 1
  }
]

export const MENU_ICON_MAP = {
  HOME: '⌂',
  INCOME: '▥',
  RESOLVE: '⌖',
  ADM: '◎',
  INCOME_STATIC: '▦',
  INCOME_IMPORT: '▤',
  RESOLVE_ADDRESS: '⌖',
  ADM_USER: '◎'
}

const PAGE_MENU_CODES = ['HOME', 'INCOME_STATIC', 'INCOME_IMPORT', 'RESOLVE_ADDRESS', 'ADM_USER']

export function readStoredMenuList() {
  try {
    const value = window.localStorage.getItem('menuList')
    const menuList = value ? JSON.parse(value) : []
    return Array.isArray(menuList) ? menuList : []
  } catch (error) {
    return []
  }
}

export function getAvailableMenuList() {
  const menuList = readStoredMenuList()
  return menuList.length ? menuList : DEFAULT_MENU_LIST
}

export function buildMenuTree(menuList = []) {
  const visibleMenus = menuList
    .filter(item => Number(item.isVisible) === 1)
    .slice()
    .sort((a, b) => Number(a.sortNo || 0) - Number(b.sortNo || 0))

  const nodeMap = visibleMenus.reduce((map, item) => {
    map[item.id] = {
      ...item,
      icon: item.icon || MENU_ICON_MAP[item.menuCode] || '·',
      children: []
    }
    return map
  }, {})

  const tree = []
  visibleMenus.forEach((item) => {
    const node = nodeMap[item.id]
    const parent = nodeMap[item.parentId]
    if (parent) {
      parent.children.push(node)
    } else if (item.parentId === '0' || !item.parentId) {
      tree.push(node)
    }
  })

  return tree
}

export function getFirstMenuRoute(menuList = getAvailableMenuList()) {
  const visibleMenus = menuList
    .filter(item => Number(item.isVisible) === 1 && item.routePath && PAGE_MENU_CODES.includes(item.menuCode))
    .slice()
    .sort((a, b) => Number(a.sortNo || 0) - Number(b.sortNo || 0))

  const home = visibleMenus.find(item => item.menuCode === 'HOME')
  const firstPage = visibleMenus[0]
  return (home && home.routePath) || (firstPage && firstPage.routePath) || '/home'
}

export function hasMenuPermission(menuCode) {
  if (!menuCode) return true
  const storedMenus = readStoredMenuList()
  if (!storedMenus.length) return true
  return storedMenus.some(item => Number(item.isVisible) === 1 && item.menuCode === menuCode)
}
